import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./page/Login";
import AdminLayout from "./layout/AdminLayout";
import HomeLayout from "./layout/HomeLayout";
import WebsiteHead from "./component/WebsiteHead";
import {
  ADMIN_LOGIN_PATH,
  BLOCKED_LOGIN_ALIASES,
  UNAUTH_ADMIN_REDIRECT,
} from "./helper/authPaths";

function App() {
  return (
    <div className="App min-h-screen">
      <WebsiteHead />
      <Routes>
        {/* Satu-satunya entry form login */}
        <Route path={ADMIN_LOGIN_PATH} element={<Login />} />

        {/* Alias lama / umum → beranda (bukan form login) */}
        {BLOCKED_LOGIN_ALIASES.map((path) => (
          <Route
            key={path}
            path={path}
            element={<Navigate to={UNAUTH_ADMIN_REDIRECT} replace />}
          />
        ))}

        <Route path="/admin/*" element={<AdminLayout />} />
        <Route path="/*" element={<HomeLayout />} />
      </Routes>
    </div>
  );
}

export default App;
